import React, { useEffect } from 'react';
import { useHistory } from 'react-router';

import { Loader } from 'ui/patterns';

import {
  AUTH_TOKEN,
  LOGIN_TYPE,
  LOGIN_TYPES,
  AUTH_EXPIRY_VISIBLE,
} from 'utils/authenticationHelper/authConstant';
import { AuthServiceSingleton } from 'utils/authenticationHelper/authServices';
import { setAuthCookie } from 'utils/authenticationHelper/setCookie';

export const Callback = () => {
  const history = useHistory();
  useEffect(() => {
    async function checkLogin() {
      console.log('entered callback');
      const loginType = localStorage.getItem(LOGIN_TYPE);
      const user = await AuthServiceSingleton.getInstance().getUser();
      localStorage.setItem(AUTH_TOKEN, JSON.stringify(user));
      await setAuthCookie(user.access_token);
      if (loginType === LOGIN_TYPES.REFRESH_LOGIN) {
        const win = window.open('about:blank', '_self');
        sessionStorage.removeItem(AUTH_EXPIRY_VISIBLE);
        win?.close();
      } else {
        const lastKnownLocation = localStorage.getItem('LastKnownLocation');
        history.push(lastKnownLocation ?? '/');
      }
    }
    checkLogin();
  }, []);
  return <Loader />;
};
